// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suivi-commande-title {
  position: relative;
  background-color: black;
  /* background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../../assets/image-lot/106-COORDONATEUR-SECURITE-PROTECTION-SANTE.jpg"); */
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  /* Inset horizontal = 6rem : l'image (fond) reste pleine largeur, les TEXTES s'alignent
     sur le corps des pages (suivis + detail candidature, qui sont en pleine largeur). */
  padding: 2rem 6rem;
  color: #fffdfc;
  margin-bottom: 2rem;
}

.suivi-commande-title h1,
.suivi-commande-title h2,
.suivi-commande-title .subtitle {
  color: white;
}

/* Encart orange (a gauche) des suivis de commande (BC + MS, acheteur & presta) : statut en haut,
   n° de panier (numero initial), sensibilite (MS), n° de marche. Ligne flex encart | contenu. */
.suivi-header__row {
  display: flex;
  align-items: center;
  gap: 2.4rem;
}
.suivi-header__col {
  flex: 1 1;
  min-width: 0;
}
.suivi-header__encart {
  flex-shrink: 0;
  align-self: center;
  min-width: 22rem;
  max-width: 28rem;
  background: #f97316;
  color: #fff;
  border-radius: 12px;
  padding: 1.4rem 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
/* Statut = bandeau BLANC pleine largeur, CENTRE : nom en MAJUSCULES colore par statut (plus de libelle
   "Statut :"). Tient TOUJOURS sur une ligne (nowrap), taille reduite pour absorber les libelles longs. */
.suivi-header__encart-statut {
  background: #fff;
  border-radius: 8px;
  padding: 0.5rem 0.8rem;
  font-size: 1.3rem;
  font-weight: 700;
  line-height: 1.3;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* Lignes n° panier / n° marche : "label : valeur" sur UNE ligne (inline), alignees a gauche. */
.suivi-header__encart-ligne {
  font-size: 1.3rem;
  line-height: 1.4;
}
/* Variante bloc : label puis valeur sur DEUX lignes (n° de marche, valeur longue type "MS-25-..."). */
.suivi-header__encart-ligne--bloc {
  display: flex;
  flex-direction: column;
}
.suivi-header__encart-lbl {
  font-weight: 500;
  opacity: 0.9;
}
.suivi-header__encart-val {
  font-weight: 700;
  word-break: break-word;
}
/* Chrono en bas de l'encart orange : libelle "Temps restant :" au-dessus, valeur en BLANC sans
   encadrement, le tout centre. On neutralise le fond blanc / la bordure / la couleur d'urgence. */
.suivi-header__encart-chrono {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.15rem;
}
.suivi-header__encart-chrono-lbl {
  font-size: 1.1rem;
  font-weight: 500;
  opacity: 0.9;
}
.suivi-header__encart-chrono .countdown-container {
  background: transparent;
  border-radius: 0;
  padding: 0;
  color: #fff;
}
.suivi-header__encart-chrono .countdown,
.suivi-header__encart-chrono .countdown.urgent,
.suivi-header__encart-chrono .countdown.warning,
.suivi-header__encart-chrono .countdown.normal,
.suivi-header__encart-chrono .countdown.expired {
  background: transparent;
  border: none;
  padding: 0;
  color: #fff;
  font-size: 1.6rem;
  font-weight: 700;
}

/* Sensibilite (MS) deplacee dans le bloc de droite : une ligne, blanche, sur le fond sombre. */
.suivi-header__sensibilite {
  color: #fff;
  font-size: 1.5rem;
  font-weight: 500;
  margin: 0.2rem 0 0.6rem;
}

/* Retour en TEXTE (style login) au lieu du chevron : BLANC, sur UNE ligne, sur le fond sombre. */
.suivi-header__back {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-bottom: 1.2rem;
  color: #fff;
  font-size: 1.4rem;
  font-weight: 500;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  transition: color 0.15s ease;
}
.suivi-header__back:hover {
  color: #f97316;
}

.suivi-commande-title h1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}

.subtitle {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 1.6rem;
  font-weight: 500;
}

.status-header span {
  font-size: 1.6rem;
  font-weight: 700;
  /* color: black; */
}

/* Classes de statuts */
.status-accepté {
  color: #00a708;
}

.status-brouillon {
  color: #6b7280;
}

.status-action-requise,
.status-analyser,
.status-signer,
.status-candidater,
.status-a-valider {
  color: #f4751b;
}

.status-refuser,
.status-refusé {
  color: #d90e0e;
}

.status-expirer,
.status-expiré,
.status-expire {
  color: #d90e0e;
}

.status-annulé,
.status-annuler {
  color: #d90e0e;
}

.status-en-attente {
  color: #6b7280;
}

.status-text {
  color: black;
}

/* Rapatrie du CSS legacy (SuiviOperation.css) : le compte a rebours du header perdait son fond/arrondi apres neutralisation des pages legacy. */
.countdown-container {
  display: inline-flex;
  align-items: center;
  background-color: white;
  border-radius: 10px;
  padding: 0.4rem 0.85rem;
  /* Texte foncé : le préfixe « Fin de dépôt … » heritait du blanc du titre -> invisible sur le fond blanc du chrono. */
  color: #2c3948;
}
`, "",{"version":3,"sources":["webpack://./src/composants/SuiviHeader/SuiviHeader.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB;mFACiF;EACjF,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B;wFACsF;EACtF,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;gGACgG;AAChG;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yCAAyC;AAC3C;AACA;yGACyG;AACzG;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,+FAA+F;AAC/F;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA,sGAAsG;AACtG;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;kGACkG;AAClG;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;AACA;;;;;EAKE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,+FAA+F;AAC/F;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,iGAAiG;AACjG;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,gJAAgJ;AAChJ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,qHAAqH;EACrH,cAAc;AAChB","sourcesContent":[".suivi-commande-title {\n  position: relative;\n  background-color: black;\n  /* background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),\n    url(\"../../assets/image-lot/106-COORDONATEUR-SECURITE-PROTECTION-SANTE.jpg\"); */\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  /* Inset horizontal = 6rem : l'image (fond) reste pleine largeur, les TEXTES s'alignent\n     sur le corps des pages (suivis + detail candidature, qui sont en pleine largeur). */\n  padding: 2rem 6rem;\n  color: #fffdfc;\n  margin-bottom: 2rem;\n}\n\n.suivi-commande-title h1,\n.suivi-commande-title h2,\n.suivi-commande-title .subtitle {\n  color: white;\n}\n\n/* Encart orange (a gauche) des suivis de commande (BC + MS, acheteur & presta) : statut en haut,\n   n° de panier (numero initial), sensibilite (MS), n° de marche. Ligne flex encart | contenu. */\n.suivi-header__row {\n  display: flex;\n  align-items: center;\n  gap: 2.4rem;\n}\n.suivi-header__col {\n  flex: 1;\n  min-width: 0;\n}\n.suivi-header__encart {\n  flex-shrink: 0;\n  align-self: center;\n  min-width: 22rem;\n  max-width: 28rem;\n  background: #f97316;\n  color: #fff;\n  border-radius: 12px;\n  padding: 1.4rem 1.6rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n}\n/* Statut = bandeau BLANC pleine largeur, CENTRE : nom en MAJUSCULES colore par statut (plus de libelle\n   \"Statut :\"). Tient TOUJOURS sur une ligne (nowrap), taille reduite pour absorber les libelles longs. */\n.suivi-header__encart-statut {\n  background: #fff;\n  border-radius: 8px;\n  padding: 0.5rem 0.8rem;\n  font-size: 1.3rem;\n  font-weight: 700;\n  line-height: 1.3;\n  text-align: center;\n  text-transform: uppercase;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n/* Lignes n° panier / n° marche : \"label : valeur\" sur UNE ligne (inline), alignees a gauche. */\n.suivi-header__encart-ligne {\n  font-size: 1.3rem;\n  line-height: 1.4;\n}\n/* Variante bloc : label puis valeur sur DEUX lignes (n° de marche, valeur longue type \"MS-25-...\"). */\n.suivi-header__encart-ligne--bloc {\n  display: flex;\n  flex-direction: column;\n}\n.suivi-header__encart-lbl {\n  font-weight: 500;\n  opacity: 0.9;\n}\n.suivi-header__encart-val {\n  font-weight: 700;\n  word-break: break-word;\n}\n/* Chrono en bas de l'encart orange : libelle \"Temps restant :\" au-dessus, valeur en BLANC sans\n   encadrement, le tout centre. On neutralise le fond blanc / la bordure / la couleur d'urgence. */\n.suivi-header__encart-chrono {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.15rem;\n}\n.suivi-header__encart-chrono-lbl {\n  font-size: 1.1rem;\n  font-weight: 500;\n  opacity: 0.9;\n}\n.suivi-header__encart-chrono .countdown-container {\n  background: transparent;\n  border-radius: 0;\n  padding: 0;\n  color: #fff;\n}\n.suivi-header__encart-chrono .countdown,\n.suivi-header__encart-chrono .countdown.urgent,\n.suivi-header__encart-chrono .countdown.warning,\n.suivi-header__encart-chrono .countdown.normal,\n.suivi-header__encart-chrono .countdown.expired {\n  background: transparent;\n  border: none;\n  padding: 0;\n  color: #fff;\n  font-size: 1.6rem;\n  font-weight: 700;\n}\n\n/* Sensibilite (MS) deplacee dans le bloc de droite : une ligne, blanche, sur le fond sombre. */\n.suivi-header__sensibilite {\n  color: #fff;\n  font-size: 1.5rem;\n  font-weight: 500;\n  margin: 0.2rem 0 0.6rem;\n}\n\n/* Retour en TEXTE (style login) au lieu du chevron : BLANC, sur UNE ligne, sur le fond sombre. */\n.suivi-header__back {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin-bottom: 1.2rem;\n  color: #fff;\n  font-size: 1.4rem;\n  font-weight: 500;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  transition: color 0.15s ease;\n}\n.suivi-header__back:hover {\n  color: #f97316;\n}\n\n.suivi-commande-title h1 {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  display: block;\n}\n\n.subtitle {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  font-size: 1.6rem;\n  font-weight: 500;\n}\n\n.status-header span {\n  font-size: 1.6rem;\n  font-weight: 700;\n  /* color: black; */\n}\n\n/* Classes de statuts */\n.status-accepté {\n  color: #00a708;\n}\n\n.status-brouillon {\n  color: #6b7280;\n}\n\n.status-action-requise,\n.status-analyser,\n.status-signer,\n.status-candidater,\n.status-a-valider {\n  color: #f4751b;\n}\n\n.status-refuser,\n.status-refusé {\n  color: #d90e0e;\n}\n\n.status-expirer,\n.status-expiré,\n.status-expire {\n  color: #d90e0e;\n}\n\n.status-annulé,\n.status-annuler {\n  color: #d90e0e;\n}\n\n.status-en-attente {\n  color: #6b7280;\n}\n\n.status-text {\n  color: black;\n}\n\n/* Rapatrie du CSS legacy (SuiviOperation.css) : le compte a rebours du header perdait son fond/arrondi apres neutralisation des pages legacy. */\n.countdown-container {\n  display: inline-flex;\n  align-items: center;\n  background-color: white;\n  border-radius: 10px;\n  padding: 0.4rem 0.85rem;\n  /* Texte foncé : le préfixe « Fin de dépôt … » heritait du blanc du titre -> invisible sur le fond blanc du chrono. */\n  color: #2c3948;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
